import * as React from 'react'

import { Card } from '@grandvisionhq/common'
import type { SummarySlotType } from '@grandvisionhq/lib-form-slots'
import { useIntl } from '@grandvisionhq/state'

const PersonalDetailsSummary: SummarySlotType<{
  email: string
}> = ({ actions, email, values = {} }) => {
  const { getLabel } = useIntl()

  return (
    <Card>
      <Card.Content>
        <Card.Actions>
          {actions?.onEdit && (
            <Card.Button onClick={actions?.onEdit} children={getLabel('common.actions.edit')} />
          )}
        </Card.Actions>
        <Card.Text variant="body-head">{`${values.firstName} ${values.lastName}`}</Card.Text>
        <Card.Text>{values.phone}</Card.Text>
        <Card.Text>{email}</Card.Text>
        <Card.Text>{values.ssn}</Card.Text>
      </Card.Content>
    </Card>
  )
}

export default PersonalDetailsSummary
